// import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { H6, LI, P, UL, Image } from "../../../AbstractElements";
// import SvgIcon from "../../../Utils/CommonComponents/CommonSvgIcons";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { dynamicImage } from "../../../Utils";
// import { Button } from "reactstrap";

// export default function UserWrap() {
//   const [open, setOpen] = useState(false);
//   const dropdownRef = useRef<HTMLLIElement>(null);
//   const navigate = useNavigate();
//   const toastIdRef = useRef<string | number | null>(null);

//   const toggle = () => {
//     setOpen(!open);
//   };

//   const confirmLogout = () => {
//     // Clear any existing toasts
//     if (toastIdRef.current) {
//       toast.dismiss(toastIdRef.current);
//     }

//     // Create new toast
//     toastIdRef.current = toast.warn(
//       <div>
//         <div>Are you sure you want to log out?</div>
//         <div className="d-flex justify-content-end mt-2">
//           <Button
//             color="danger"
//             onClick={() => {
//               logout();
//               if (toastIdRef.current) {
//                 toast.dismiss(toastIdRef.current);
//               }
//             }}
//           >
//             Yes
//           </Button>
//           <Button
//             color="secondary"
//             onClick={() => {
//               if (toastIdRef.current) {
//                 toast.dismiss(toastIdRef.current);
//               }
//             }}
//             className="ms-2"
//           >
//             No
//           </Button>
//         </div>
//       </div>,
//       {
//         position: "top-right",
//         autoClose: false,
//         closeOnClick: false,
//         closeButton: false,
//         draggable: false,
//         onClose: () => {
//           toastIdRef.current = null;
//         }
//       }
//     );
//   };

//   const logout = () => {
//     localStorage.clear();
//     toast.info("Logged out successfully!");
//     navigate("/login", { replace: true });
//   };

//   // Detect click outside dropdown
//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target as Node)
//       ) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
//     <li className="profile-nav custom-dropdown" ref={dropdownRef}>
//       <div className="user-wrap" onClick={toggle}>
//         <div className="user-img" style={{ backgroundColor: "transparent" }}>
//           <Image src={dynamicImage("profile.png")} alt="user" />
//         </div>
//         <div className="user-content">
//           <H6>{"Admin"}</H6>
//           <P className="mb-0">
//             {"Admin"}
//             <i className="fa-solid fa-chevron-down" />
//           </P>
//         </div>
//       </div>

//       <div className={`custom-menu overflow-hidden ${open ? "show" : ""}`}>
//         <UL className="profile-body simple-list">
//           <LI
//             className="d-flex"
//             onClick={() => {
//               confirmLogout();
//               setOpen(false);
//             }}
//           >
//             <SvgIcon className="svg-color" iconId="Login" />
//             <span className="ms-2 text-primary" style={{ cursor: "pointer" }}>
//               Log Out
//             </span>
//           </LI>
//         </UL>
//       </div>
//     </li>
//   );
// }




import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { H6, LI, P, UL, Image } from "../../../AbstractElements";
import SvgIcon from "../../../Utils/CommonComponents/CommonSvgIcons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { dynamicImage } from "../../../Utils";
import { Button } from "reactstrap";

export default function UserWrap() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLLIElement>(null);
  const navigate = useNavigate();
  const toastIdRef = useRef<string | number | null>(null);

  const toggle = () => {
    setOpen(!open);
  };

  const confirmLogout = () => {
    // Clear any existing toasts first
    toast.dismiss();
    
    toastIdRef.current = toast.warn(
      <div>
        <div>Are you sure you want to log out?</div>
        <div className="d-flex justify-content-end mt-2">
          <Button
            color="danger"
            onClick={() => {
              logout();
              toast.dismiss();
            }}
          >
            Yes
          </Button>
          <Button
            color="secondary"
            onClick={() => toast.dismiss()}
            className="ms-2"
          >
            No
          </Button>
        </div>
      </div>,
      {
        toastId: "logout-confirmation",
        position: "top-right",
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false,
      }
    );
  };

  const logout = () => {
    localStorage.clear();
    toast.info("Logged out successfully!");
    navigate("/login", { replace: true });
  };

  // Click outside dropdown handler
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Clear toasts when component unmounts
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

  return (
    <li className="profile-nav custom-dropdown" ref={dropdownRef}>
      <div className="user-wrap" onClick={toggle}>
        <div className="user-img" style={{ backgroundColor: "transparent" }}>
          <Image src={dynamicImage("profile.png")} alt="user" />
        </div>
        <div className="user-content">
          <H6>{"Admin"}</H6>
          <P className="mb-0">
            {"Admin"}
            <i className="fa-solid fa-chevron-down" />
          </P>
        </div>
      </div>

      <div className={`custom-menu overflow-hidden ${open ? "show" : ""}`}>
        <UL className="profile-body simple-list">
          <LI
            className="d-flex"
            onClick={() => {
              confirmLogout();
              setOpen(false);
            }}
          >
            <SvgIcon className="svg-color" iconId="Login" />
            <span className="ms-2 text-primary" style={{ cursor: "pointer" }}>
              Log Out
            </span>
          </LI>
        </UL>
      </div>
    </li>
  );
}